import { Controller } from "@hotwired/stimulus"

// Manager page form: selecting a module redirects the page elsewhere, so its own
// content is never rendered — the content editor is disabled while one is set.
export default class extends Controller {
    static targets = ["module", "content"]

    connect() {
        this.toggleContent()
    }

    toggleContent() {
        const disabled = this.moduleTarget.value !== ""

        this.contentTarget.classList.toggle("is-disabled", disabled)
        this.contentTarget
            .querySelectorAll("textarea, input, select, button")
            .forEach((field) => { field.disabled = disabled })

        // CKEditor replaces the textarea with its own editable element, which
        // ignores the disabled attribute — put it in read-only mode too. The API
        // differs by version: enable/disableReadOnlyMode landed in CKEditor 5
        // v34, older builds only have the isReadOnly setter.
        const editor = this.contentTarget.querySelector(".ck-editor__editable")?.ckeditorInstance
        if (!editor) return

        if (typeof editor.enableReadOnlyMode === "function") {
            disabled
                ? editor.enableReadOnlyMode("page-form")
                : editor.disableReadOnlyMode("page-form")
        } else {
            editor.isReadOnly = disabled
        }
    }
}
